import Signup from '../components/signupHandler';
import Mixpanel from '../modules/mixpanel';

let isSignupPage = $('body').hasClass('page--signup');

if(isSignupPage) {
  class SignupPage {
    constructor() {
      this.signup = new Signup("signupForm");
      this.spaceName = $('input[name="spaceName"]', this.signup.form);
      this.mixpanel = new Mixpanel();
      this.attachEvent();
    }

    attachEvent() {
      this.signup.submitButton.on('click', (e) => {
        e.preventDefault();
        this.spaceName.val(this.signup.fullName.val());
        if(!this.signup.finalValidate()) {
          return false;
        }
        this.sendMixpanelEvent();
        this.signup.submitForm();
        return true;
      });

    }

    sendMixpanelEvent(){
      let referringDomain = "direct"; // indicates organic access
      this.mixpanel.getParam("mp_medium", function(value){
        if(document.referrer !== "" && value !== ""){
          referringDomain = decodeURIComponent(value);
        }
      });
      let trackingData = {
        "Signup Email": this.signup.mail.val(),
        "Signup Referring Domain": referringDomain,
        "Plan Type at Signup Start": "Free"
      };

      this.mixpanel.trackSignup("Nulab Account", trackingData);
    }

  }

  new SignupPage();

}
